import type * as React from 'react';

function SvgSort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M19.5215 16.2485C19.4053 15.9682 19.1319 15.7856 18.8281 15.7856H16.75V4.6362C16.75 4.2221 16.4141 3.8862 16 3.8862C15.5859 3.8862 15.25 4.2221 15.25 4.6362V15.7856H13.1719C12.8682 15.7856 12.5948 15.9682 12.4785 16.2485C12.3633 16.5288 12.4267 16.8515 12.6416 17.0659L15.4697 19.894C15.6162 20.0405 15.8076 20.1137 16 20.1137C16.1924 20.1137 16.3838 20.0405 16.5303 19.894L19.3584 17.0659C19.5732 16.8515 19.6367 16.5288 19.5215 16.2485Z"
        fill="currentColor"
      />
      <path
        d="M8.5303 4.106C8.2373 3.813 7.7627 3.813 7.4698 4.106L4.6417 6.9341C4.4269 7.1485 4.3634 7.4712 4.4786 7.7515C4.5948 8.0318 4.8682 8.2144 5.172 8.2144H7.2501V19.3638C7.2501 19.7779 7.586 20.1138 8.0001 20.1138C8.4142 20.1138 8.7501 19.7779 8.7501 19.3638V8.2144H10.8282C11.1319 8.2144 11.4053 8.0318 11.5216 7.7515C11.6368 7.4712 11.5734 7.1485 11.3585 6.9341L8.5303 4.106Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSort;
